import React from 'react';
import { Box, Typography } from '@mui/material';

interface FooterBannerProps {
    showBanner: boolean;
}

const FooterBanner: React.FC<FooterBannerProps> = ({ showBanner }) => {
    return (
        <Box sx={{
            position: 'fixed',
            left: 0,
            bottom: 0,
            width: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            pointerEvents: 'none',
            transition: 'transform 0.5s cubic-bezier(0.4,0,0.2,1), opacity 0.5s',
            transform: showBanner ? 'translateY(0)' : 'translateY(100%)',
            opacity: showBanner ? 1 : 0,
        }}>
            <Box sx={{
                px: 3,
                py: 1.5,
                borderRadius: 4,
                background: 'rgba(30, 30, 40, 0.85)',
                backdropFilter: 'blur(12px)',
                boxShadow: '0 2px 16px rgba(63,81,181,0.15)',
                border: '1px solid rgba(255,255,255,0.12)',
                mb: 2,
                pointerEvents: 'auto',
            }}>
                <Typography variant="body2" sx={{
                    color: 'text.secondary',
                    fontWeight: 500,
                    fontSize: '1rem',
                    letterSpacing: '0.02em',
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                }}>
                    Made with 💕 for the Mako Magic Community
                </Typography>
            </Box>
        </Box>
    );
};

export default FooterBanner;
